import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme) => ({
  teamContainer: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column'
  },
  teamWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      flexDirection: 'column',
      justifyContent: 'center'
    }
  },
  teamInformation: {
    display: 'flex',
    paddingRight: theme.spacing(6),
    flexDirection: 'column',
    justifyContent: 'space-between',
    [theme.breakpoints.up('xxl')]: {
      width: '50%',
      justifyContent: 'left'
    }
  },
  teamDescription: {
    marginTop: theme.spacing(1)
  },
  teamMetricsSection: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2)
    },
    [theme.breakpoints.up('xxl')]: {
      paddingTop: theme.spacing(5)
    }
  },
  teamMetricsValue: {
    color: theme.palette.primary.contrastText
  },
  teamMetricsText: {
    fontWeight: 500
  },
  laboratoryImg: {
    width: '50%',
    height: '225px',
    objectFit: 'contain',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: 'auto',
      padding: theme.spacing(1)
    },
    [theme.breakpoints.up('xxl')]: {
      width: '45%',
      objectFit: 'cover',
      objectPosition: 'center',
      borderRadius: '30px',
      height: '360px'
    }
  },
  spacing: {
    marginTop: theme.spacing(7),
    marginBottom: theme.spacing(3)
  },
  gridContainer: {
    margin: 0
  },
  gridItemStructureList: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '10px'
  },
  iconBackground: {
    backgroundColor: theme.palette.secondary.main,
    padding: theme.spacing(1),
    borderRadius: '50%',
    width: '55px',
    height: '55px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '46px',
      height: '46px'
    }
  },
  icon: {
    width: '30px',
    [theme.breakpoints.down('sm')]: {
      width: '24px'
    }
  },
  technologiesTextIcon: {
    flexGrow: 1,
    fontWeight: 500,
    maxWidth: '280px'
  },
  structureSwiperContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(0)
    },
    [theme.breakpoints.up('xxl')]: {
      marginTop: theme.spacing(3)
    }
  },
  swiperContainer: {
    width: '100%',
    padding: '50px 0',
    '& .swiper-slide': {
      transition: 'all 0.4s ease',
      transform: 'scale(0.6)',
      opacity: 0.7,
      display: 'flex',
      justifyContent: 'center'
    },
    '& .swiper-slide-active, & .swiper-slide-duplicate-active': {
      transform: 'scale(1.2)',
      opacity: 1,
      zIndex: 2
    }
  },
  swiperSlideImg: {
    width: '100%',
    maxWidth: '450px',
    borderRadius: '30px',
    objectFit: 'cover',
    [theme.breakpoints.down('md')]: {
      maxWidth: '250px',
      objectFit: 'scale-down'
    },
    [theme.breakpoints.up('xxl')]: {
      maxWidth: '600px'
    }
  },
  navButton: {
    color: theme.palette.primary.contrastText
  }
}))
